export default __webpack_public_path__ + "media/images/front/about/point_1-00870b7517d3310a5753d73376ec3182.png";